import tpl from './tpl';
import api from './api.js';
import {getGlobalInfo} from "../userApi/api";
import {getBizDomain} from "../utils/domain";

let elements = {}, systemKey, hasMove = false;

const STANDARD = "standard";

let config = {
    'test-partner': {
        menuId: '',
        keyWord: '',
        host: `testpartner.${getBizDomain()}`,
        appId: "pm4uKg7g",
        appSecret: "24374E73C6EDBB007C1B368DCDB3E252",
    },
    'partner': {
        menuId: '',
        keyWord: '',
        // host: 'partner.dmall.com',
        host: `partner.${getBizDomain()}`,
        appId: "zL4itluW",
        appSecret: "8F920A1652C5D8805B36B500D76E9E40",
    },
    'test-pop': {
        style: 'robot',
        menuId: '',
        keyWord: '',
        // host: 'testpop.dmall.com',
        host: `testpop.${getBizDomain()}`,
        appId: "JVUQmjh9",
        appSecret: "CAE566B3A53B7EC77C1B368DCDB3E252",
    },
    'pop': {
        style: 'robot',
        menuId: '',
        keyWord: '',
        // host: 'dm.dmall.com',
        host: `dm.${getBizDomain()}`,
        appId: "nlBhuqKR",
        appSecret: "82005C9A49C82ED35B36B500D76E9E40",
    },
    // 'localhost': {
    //     menuId: '',
    //     keyWord: '',
    //     style: 'robot',
    //     host: 'localhost',
    //     appId: "JVUQmjh9",
    //     appSecret: "CAE566B3A53B7EC77C1B368DCDB3E252",
    // },
    'testlocal': {
        menuId: '',
        keyWord: '',
        style: 'robot',
        // host: 'testlocal.dmall.com',
        host: `testlocal.${getBizDomain()}`,
        appId: "fdd802102ccd45b8bc84a2e86c9af83b",
        appSecret: "36B3AB1DCD2B16F31A5C893B3CF17058",
    },
    'teststatic': {
        menuId: '',
        keyWord: '',
        style: 'robot',
        // host: 'teststatic.dmall.com',
        host: `teststatic.${getBizDomain()}`,
        appId: "fdd802102ccd45b8bc84a2e86c9af83b",
        appSecret: "36B3AB1DCD2B16F31A5C893B3CF17058",
    },
    [STANDARD]: {
        menuId: '',
        keyWord: '',
        host: '',
        appId: "",
        appSecret: "",
    }
}

function refresh(){
    setTimeout(function(){
        init();
        urlChange();
    }, 1000)
}

refresh()

// 创建入口
function init(){
    isVisible().then(res =>{
        if(res){
            loadElements();
            getRightMenus();
            layoutDiff();
            addEvent();
        } else{
            if(document.querySelector('.help-body')){
                document.querySelector('.help-body').style.display = 'none';
            }
            refresh()
        }
    })
}

function loadElements(){
    if(elements && elements.helpBody){
        document.body.removeChild(elements.helpBody)
    }
    if(document.querySelector('.help-chat-content')){
        document.querySelector('.help-chat-content').innerHTML = '';
    }
    Object.keys(config).map(key =>{
        config[key].keyWord = '';
    })
    document.body.appendChild(parseElement(tpl));
    elements = {
        'helpBody': document.querySelector('.help-body'),
        'entry': document.querySelector('.help-entry'),
        'menu': document.querySelector('.help-menu'),
        'menuClose': document.querySelector('.help-menu-close'),
        'menuGuess': document.querySelector('.help-guess'),
        'chatIcon': document.querySelector('.help-chat-default-avatar'),
        'questions': document.querySelector('.help-ul'),
        'chatBody': document.querySelector('.help-chat-body'),
        'chatClose': document.querySelector('.help-chat-close'),
        'chatContent': document.querySelector('.help-chat-content'),
        'textArea': document.querySelector('.help-input-message'),
        'send': document.querySelector('.help-send-button'),
    }
    drag();
}

//布局区别
function layoutDiff(){
    const sName = config[systemKey].style
    if(sName){
        elements.chatIcon.classList.remove('icon-help')
        elements.chatIcon.classList.add('icon-' + sName)
        elements.chatIcon.style.backgroundSize = '38px'

        elements.entry.classList.remove('icon-help')
        elements.entry.classList.add('icon-' + sName + '-default-size')
        elements.entry.style.height = '42px'

        elements.menuClose.classList.remove('icon-help')
        elements.menuClose.classList.remove('help-menu-close')
        elements.menuClose.classList.add('icon-top')
        elements.menuClose.classList.add('icon-' + sName)
    }
}


//右侧菜单
function getRightMenus(){
    console.log('menuId', config[systemKey].menuId);
    // todo
    api.getSearch(config[systemKey]).then(result =>{
        if(result.code == "1001"){  //无消息 给出机器人提示
            elements.helpBody.style.display = 'none';
        }
        else if(result.code == '1002'){
            elements.helpBody.style.display = 'none';
        }
        else{
            elements.helpBody.style.display = 'block';
            result.data && result.data.list.map(item =>{
                elements.questions.appendChild(parseElement(`<li page-id="${item.id}">${item.title}</li>`))
            })

            for(let i = 0; i < elements.questions.children.length; i++){
                elements.questions.children[i].onclick = function(){
                    elements.chatBody.style.display = 'flex';
                    let id = elements.questions.children[i].getAttribute('page-id');
                    insertMessage('right', elements.questions.children[i].textContent);
                    insertMessage('left', result.data.list.filter(item => item.id === id)[0].content, result.data.list.filter(item => item.id === id)[0].title);
                }
            }
        }
    })
}

function getMenuId(){
    return new Promise((resolve, reject) =>{
        setTimeout(() =>{
            let visible = false;

            // 标准接入方式
            if(systemKey === STANDARD){
                let lineInfo = getGlobalInfo()
                const {appId, appSecret, style, currentMenuInfo} = lineInfo;

                if(!appId || !appSecret){
                    console.error("未全局写入小组件业务线的appId和appSecret")
                }else{
                    config[systemKey].appId = appId;
                    config[systemKey].appSecret = appSecret;
                    config[systemKey].style = style;

                    config[systemKey].menuId = currentMenuInfo.menuId;
                    config[systemKey].menuName = currentMenuInfo.menuName;

                    visible = true;
                }
            }
            // 来客、pop接入方式
            else{
                let actives = document.querySelectorAll('.active');
                for(let i = 0; i < actives.length; i++){
                    let active = actives[i];
                    if(active.href && active.getAttribute('page-id') && active.href.search('#') != '-1'){
                        visible = true;
                        config[systemKey].menuId = active.getAttribute('page-id');
                        config[systemKey].menuName=active.textContent.trim();
                        window.menuId = active.getAttribute('page-id');
                    }
                }
            }

            return resolve(visible);
        }, 1000)
    })
}

//是否展示入口
function isVisible(){
    let visible = false;
    Object.keys(config).map(key =>{
        if(location.href.indexOf(config[key].host) >= 0 && !systemKey){
            systemKey = key;
        }
    })

    systemKey = systemKey || STANDARD;
    return new Promise((resolve, reject) =>{
        if(systemKey){
            getMenuId().then(res =>{
                visible = res;
                return resolve(visible);
            })
        }else{

        }
    })
}

//添加事件
function addEvent(){

    elements.entry.onclick = function(){
        if(!hasMove){
            elements.menu.style.display = 'block';
            elements.entry.style.display = 'none';
        }
    }

    elements.menuGuess.onclick = function(){
        if(!hasMove){
            elements.menu.style.display = 'none';
            elements.entry.style.display = 'block';
        }
    }

    elements.chatClose.onclick = function(){
        elements.chatBody.style.display = 'none';
    }

    elements.send.onclick = function(){
        send(elements.textArea.value)
    }

    elements.textArea.addEventListener("keyup", function(e){
        if(e.keyCode == 13 && e.ctrlKey){
            elements.textArea.value += "\n"; //换行
        }
        else if(e.keyCode === 13){
            elements.textArea.value = elements.textArea.value.substring(0, elements.textArea.value.length - 1)
            send(elements.textArea.value)
        }
    })
}

//发送
function send(message){
    if(message){
        elements.textArea.value = '';
        insertMessage('right', message);
        config[systemKey].keyWord = message;
        api.getSearch(config[systemKey]).then(result =>{
            if(result.code == "1001"){  //无消息 给出机器人提示
                insertMessage('left', result.msg, message);
            }
            else if(result.data.list.length == 1){ // 只有一个搜索结果,直接给出答案；
                insertMessage('left', result.data.list[0].content, result.data.list[0].title);
            }
            else{  // 正常结果返回
                const div = document.createElement("div");
                const ul = document.createElement("ul");
                div.classList.add("help-search-ul")
                result.data.list.map(item =>{
                    ul.appendChild(parseElement(`<li page-id="${item.id}" >${item.title}</li>`))
                })
                div.appendChild(parseElement(`<span>请选择您的问题:</span>`));
                div.appendChild(ul);
                insertMessage('left', parseDomString(div));

                // 添加事件
                const lis = elements.chatContent.getElementsByTagName('li');
                for(let i = 0; i < lis.length; i++){
                    lis[i].onclick = function(){
                        let id = lis[i].getAttribute('page-id');
                        insertMessage('right', lis[i].textContent);
                        const item = result.data.list.filter(item => item.id == id);
                        insertMessage('left', item[0].content, lis[i].textContent);
                    }
                }
            }
        });


    }
}


//插入文本消息
function insertMessage(direction, message, title){
    new Promise((resolve ,reject)=>{
        let spans=document.querySelectorAll('.help-chat-text');
        let content = message.replace(/\n/g, "</br>"); //换行
        // let http_url = httpUrlString(content); //截取url
        // if(http_url){
        //     content = content.replace(http_url, ` <a href="${http_url[0]}" target="_blank">${http_url[0]}</a> `)
        // }
        let html = `<div class="context-${direction}">
                   <span class="help-chat-text" id="last-${spans.length}">
                     ${title ? '<div class="title">' + title + '</div>' : ''}
                     ${content}
                   </span>
              </div>`
        elements.chatContent.appendChild(parseElement(html));
        return resolve()
    }).then(()=>{
        scrollToBottom();
    })
}

//文本中是否有url
function httpUrlString(s){
    var reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
    s = s.match(reg);
    return (s)
}


//string 转化Node
function parseElement(htmlString){
    return new DOMParser().parseFromString(htmlString, 'text/html').body.childNodes[0]
}

//Node 转化成string
function parseDomString(node){
    const div = document.createElement("div")
    div.appendChild(node)
    return div.innerHTML;
}

//可拖拽
function drag(){
    move(elements.entry)
    move(elements.menu)
}

function move(el){
    if(el == null) return;
    el.onmousedown = function(e){
        hasMove = false;
        var ev = e || window.event;  //兼容ie浏览器
        //鼠标点击物体那一刻相对于物体左侧边框的距离=点击时的位置相对于浏览器最左边的距离-物体左边框相对于浏览器最左边的距离
        var distanceX = ev.clientX - el.offsetLeft;
        var distanceY = ev.clientY - el.offsetTop;
        document.onmousemove = function(e){
            hasMove = true;
            // console.log('开始移动:', hasMove)
            var ev = e || window.event;  //兼容ie浏览器
            // el.style.left = ev.clientX - distanceX + 'px';
            // el.style.top = ev.clientY - distanceY + 'px';

            elements.entry.style.left = ev.clientX - distanceX + 'px';
            elements.entry.style.top = ev.clientY - distanceY + 'px';
            elements.menu.style.left = ev.clientX - distanceX + 'px';
            elements.menu.style.top = ev.clientY - distanceY + 'px';
        };
        document.onmouseup = function(){
            document.onmousemove = null;
            document.onmouseup = null;
            setTimeout(() =>{
                // console.log('移动完成:', hasMove)
                hasMove = false;
            }, 1)
        };
        e.preventDefault();
    };
}

//滚动条滚动到底
function scrollToBottom(){
    let content = document.querySelector('.help-chat-content');
    setTimeout(()=>{
        content.scrollTop = content.scrollHeight;
    },1000)

}

//url 发送变化 重新获取配置信息
function urlChange(){
    if(('onhashchange' in window) && ((typeof document.documentMode === 'undefined') || document.documentMode == 8)){
        // 浏览器支持onhashchange事件
        window.onhashchange = () =>{
            console.log('change')
            init()
        }
    } else{
        // 不支持则用定时器检测的办法
        let hash = window.location.hash;
        setInterval(function(){
            // 检测hash值或其中某一段是否更改的函数， 在低版本的iE浏览器中通过window.location.hash取出的指和其它的浏览器不同，要注意
            let newHash = window.location.hash;
            if(hash != newHash){
                console.log('change')
                hash = newHash;
                init();
            }
        }, 2000);
    }
}

